import React from "react";

class Contact extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="page-image" />
        <div className="container section row">
          <h5>Contact Us</h5>
          <div className="col offset-s1 s10 m3 l3 contact-bio">
            <p>
              <strong>Growth Property Group LLC</strong>
              <br />
              {" 36 Laight Street"}
              <br />
              {" Unit 3A"}
              <br />
              {" New York, NY"}&nbsp;{"10013"}
              <br />
            </p>
          </div>
          <div className="col offset-s1 s10 m3 l3 contact-bio">
            <p>
              <strong>
                Business Development <br /> Aquisitions | Asset Management
              </strong>
              <br />
              {" Maxwell Ullman"}
              <br />
              {" mullman@growthproperty.us"}
              <br />
              {" T: 858.243.3178"}
            </p>
          </div>
          <div className="col offset-s1 s10 m3 l3 contact-bio">
            <p>
              <strong>Investor Relations | Finance</strong>
              <br />
              {" Daniyel Cohen"}
              <br />
              {" dcohen@growthproperty.us"}
              <br />
              {" T: 617.817.9316"}
            </p>
          </div>
          <div className="col offset-s1 s10 m3 l3 contact-bio">
            <p>
              <strong>
                General Counsel
              </strong>
              <br />
              {" William M. Koslow"}
              <br />
              {"Koslow Law PLC"}
              <br />
              {"wkoslow@klplc.com"}
              <br />
              {" T: 646.831.1997"}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;
